// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bcb05134","220":"e1a8df2d","231":"98b4a883","256":"123805ea","262":"a41cabee","308":"f3c09c8d","453":"64aababc","485":"67f3959c","634":"a149955d","686":"87f2f4f4","871":"379985a5","882":"84f9d598","925":"dba81441","998":"404c295b"}[chunkId] + ".chunk.js";
};